module.exports = __webpack_public_path__ + "img/Navy.1719ee3a.png";